import { render, staticRenderFns } from "./comp-rtc-stream.vue?vue&type=template&id=acd07e24&scoped=true&lang=pug&"
import script from "./comp-rtc-stream.vue?vue&type=script&lang=js&"
export * from "./comp-rtc-stream.vue?vue&type=script&lang=js&"
import style0 from "./comp-rtc-stream.vue?vue&type=style&index=0&id=acd07e24&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acd07e24",
  null
  
)

export default component.exports